<template>

    <m-edit1/>

    <m-single-category-300 v-bind='{...{"categoryLink":null,"relatedPosts":true},...{}}' :style='""' class="container my-5" ></m-single-category-300><m-div v-bind='{...{},...{}}' :style='""' class="text-center container mb-4" >
                <template #default>   <m-button-9 v-bind='{...{"type":"button","href":"https:\/\/www.amudco.com\/en\/blog","target":"_self"},...{}}' :style='""' class="" >
                <template #default>know more...   </template>
                </m-button-9></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleCategory300 from '@moeinmdn/miw-alpha-components/src/package/Category/Single/SingleCategory300'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mButton9 from '@moeinmdn/miw-alpha-components/src/package/Buttons/Button9';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleCategory300,mDiv,mButton9 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
